module.exports = __webpack_public_path__ + "img/fmmick.cdaebb50.svg";